import React from 'react';
import Component from '@vfuk/core-side-tray';
const SideTray = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SideTray;
